"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'mark';
var Mark = /** @class */ (function (_super) {
    __extends(Mark, _super);
    function Mark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'mark'; };
        _this.textMatcher = [
            {
                matcher: /\=\=(.*)\=\=\s/
            }
        ];
        _this.parseDOM = [{ tag: 'mark' }];
        return _this;
    }
    return Mark;
}(core_utilities_1.Inline));
exports.Mark = Mark;
var MarkController = /** @class */ (function (_super) {
    __extends(MarkController, _super);
    function MarkController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'mark',
            tooltip: 'mark'
        };
        return _this;
    }
    return MarkController;
}(core_utilities_1.SylController));
exports.MarkController = MarkController;
var MarkPlugin = /** @class */ (function (_super) {
    __extends(MarkPlugin, _super);
    function MarkPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = MarkController;
        _this.Schema = Mark;
        return _this;
    }
    return MarkPlugin;
}(core_utilities_1.SylPlugin));
exports.MarkPlugin = MarkPlugin;
//# sourceMappingURL=mark.js.map